import React from 'react';

import {
    useUpdateShellPrimary,
    useUpdateShellSecondary
} from '../../shell/hooks/shellHooks.js';

import {
    ConfigurationProvider
} from '../../../hooks/widgetConfiguration.js';

import PoweredByQuid from '../components/PoweredByQuid.jsx';

import QuidTopicListWidget from '../components/QuidTopicListWidget.jsx';

import {
    ConfigureTopicModal
} from '../components/ConfigureTopicModal.jsx';

import {
    useIsExporting
} from '../../../hooks/useExport.js';

import InvalidQuidMonitorTokenErrorPage from '../components/InvalidQuidMonitorTokenErrorPage.jsx';
import useHasValidQuidMonitorToken from '../hooks/useHasValidQuidMonitorToken.js';

const shellPrimaryConfiguration = {
    companySets: {
        disabled: true
    },
    dataFreshness: {
        disabled: true
    },
    sidebar: {
        id: 'social_listening_quid_topics'
    },
    timePeriodDateRangeRestrictions: {
        periods: {
            [RivalIQ.enums.timePeriod.periodType.COMPARE_PERIOD]: {
                disabled: true,
                mask: (
                    RivalIQ.enums.timePeriod.comparePeriodType.PREVIOUS_PERIOD |
                    RivalIQ.enums.timePeriod.comparePeriodType.CUSTOM
                )
            }
        }
    }
};


function CurationLayout() {

    useUpdateShellPrimary('Quid Monitor Topics', shellPrimaryConfiguration);
    const isExporting = useIsExporting();
    useUpdateShellSecondary(false);

    const hasValidQuidMonitorToken = useHasValidQuidMonitorToken();

    if (!hasValidQuidMonitorToken) {
        return <InvalidQuidMonitorTokenErrorPage/>;
    }

    return (
        <>
            {!isExporting &&
                <ConfigureTopicModal />
            }
            <QuidTopicListWidget
                instanceId='quid-topics'
            />

            <PoweredByQuid />
        </>
    );
}

export default function QuidTopicsCuration(props) {

    const defaultProps = {
        instanceId: props?.instanceId,
        scheduleId: props?.scheduleId
    };

    const configurationSchema = {
    };

    return (
        <ConfigurationProvider
            defaultProps={defaultProps}
            configurationSchema={configurationSchema}
        >
            <CurationLayout />
        </ConfigurationProvider>
    );
}
